import { render, staticRenderFns } from "./detail-site.vue?vue&type=template&id=a6b2cb66&scoped=true"
import script from "./detail-site.vue?vue&type=script&lang=js"
export * from "./detail-site.vue?vue&type=script&lang=js"
import style0 from "./detail-site.vue?vue&type=style&index=0&id=a6b2cb66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b2cb66",
  null
  
)

export default component.exports